import {setUser} from '@sentry/browser';
import {useCallback, useEffect} from 'react';

import type {AuthenticatedUser} from '@/api/types/__generated__/graphql';
import {useAuthenticatedUser} from '@/api/users/useAuthenticatedUser';
import {getConfig} from '@/config';
import {isDefined} from '@/utils/typeGuards/isDefined';

const config = getConfig();

export function SentrySetup() {
    const {user} = useAuthenticatedUser();

    const setUserSentry = useCallback(() => {
        const userId = (user as AuthenticatedUser).userId.toString();
        setUser({name: `User ${userId}`, id: userId});
        console.log('Sentry: User identified');
    }, [user]);

    useEffect(() => {
        if (config.SENTRY.ACTIVE && isDefined(user)) {
            setUserSentry();
        }
    }, [user, setUserSentry]);

    return null;
}
